export const chevron_down = () => (
  <path
    d="M6 9l6 6 6-6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
